<template>
  <div>
    test page
    <audioWave
      :PropsAudioUrl="PropsAudioUrl"
      :PropsBatchDate="PropsBatchDate"
      :PropsAudioName="PropsAudioName"
      :PropsHasLabeled="PropsHasLabeled"
      :PropsWantEmitEvent="PropsWantEmitEvent"
      @feedbackDataToParent="getBackFromChild"
    ></audioWave>
    <!-- <button @click="triggerPropsWantEmitEvent()"> button </button> -->
  </div>
</template>
<script>
import audioWave from '@/components/audioWave/index.vue';

export default {
  components: { audioWave },
  data() {
    return {
      dataGetBackFromChild: [],
      PropsWantEmitEvent: false,
      PropsStatus: 'cry',
      PropsAudioUrl: null,
      PropsBatchDate: '',
      PropsAudioName: '',
      PropsHasLabeled: [
        {
          status: 'cry',
          start_ms: '123',
          end_ms: '1234',
        },
      ],
      batch: {
        batchType: 'audio',
      },
    };
  },
  methods: {
    getBackFromChild(data) {
      const vm = this;
      vm.dataGetBackFromChild = data;
      console.log('parent');
      console.log(vm.dataGetBackFromChild);
    },
  },
  // watch: {
  //   dataGetBackFromChild() {
  //     console.log("dataGetBackFromChild");
  //     console.log(vm.dataGetBackFromChild);

  //   }
  // },
  mounted() {
    const vm = this;
    vm.$store.dispatch('Gettask', vm.batch.batchType).then((response) => {
      console.log('Pageresponse: ');
      console.log(response);
      vm.PropsBatchDate = response.batch_date;
      vm.PropsAudioName = response.name;
      vm.PropsAudioUrl = `${process.env.VUE_APP_API}/data/audio/${vm.PropsBatchDate}/${vm.PropsAudioName}`;
      console.log('PagePropsaudioUrl: ');
      console.log(vm.PropsAudioUrl);
    });
  },
};
</script>
